/**
 * 提示音模块
 */

const getDefaultState = () => {
  return {
    muted: false, // 默认不静音
    newMessageMuted: false, // 新消息提示音静音状态
    likeMessageMuted: false, // 点赞消息提示音静音状态
  };
};

export default {
  name: 'sound',
  namespaced: true, // 启用命名空间
  state: getDefaultState(),
  getters: {
    isMuted: (state) => state.muted,
    isNewMessageMuted: (state) => state.newMessageMuted,
    isLikeMessageMuted: (state) => state.likeMessageMuted,
    getSoundStatus: (state) => (state.muted ? '静音' : '非静音'),
  },
  mutations: {
    SET_RING_VAL(state, val) {
      state.muted = val;
    },
    TOGGLE_MUTED(state) {
      state.muted = !state.muted;
    },
    SET_NEW_MESSAGE_MUTED(state, val) {
      state.newMessageMuted = val;
    },
    SET_LIKE_MESSAGE_MUTED(state, val) {
      state.likeMessageMuted = val;
    },
    TOGGLE_NEW_MESSAGE_MUTED(state) {
      state.newMessageMuted = !state.newMessageMuted;
    },
    TOGGLE_LIKE_MESSAGE_MUTED(state) {
      state.likeMessageMuted = !state.likeMessageMuted;
    },
  },
  actions: {
    setRingVal({ commit }, val) {
      commit('SET_RING_VAL', val);
    },
    toggleMuted({ commit }) {
      commit('TOGGLE_MUTED');
    },
    setNewMessageMuted({ commit }, val) {
      commit('SET_NEW_MESSAGE_MUTED', val);
    },
    setLikeMessageMuted({ commit }, val) {
      commit('SET_LIKE_MESSAGE_MUTED', val);
    },
    toggleNewMessageMuted({ commit }) {
      commit('TOGGLE_NEW_MESSAGE_MUTED');
    },
    toggleLikeMessageMuted({ commit }) {
      commit('TOGGLE_LIKE_MESSAGE_MUTED');
    },
  },
};
